import { ShiftsDeleteSchema, ShiftsDeleteSchemaType } from './schema'

interface FormOptions {
  startAt?: Date
  endAt?: Date
  employeeSelection?: ShiftsDeleteSchemaType['employeeSelection']
}

const Form = (options: FormOptions = {}) => {
  const defaultValues: ShiftsDeleteSchemaType = {
    startAt: options.startAt ?? new Date(),
    endAt: options.endAt ?? new Date(),
    employeeId: null,
    employeeSelection:
      options.employeeSelection ?? {
        type: 'manual',
        ids: [],
      },
  }

  return {
    defaultValues,
    schema: ShiftsDeleteSchema(),
  }
}

export { Form }
